module.exports = __webpack_public_path__ + "icon-arrow-right-charcoal.751f110d8fa9688ae8f3.svg";